export default "__VITE_ASSET__5eb7cab5__"